export default __webpack_public_path__ + "static/media/36I-102752_-15853_0.e33c658f.jpg";